import { render, staticRenderFns } from "./myCanvas.vue?vue&type=template&id=444f4278&scoped=true&"
import script from "./myCanvas.vue?vue&type=script&lang=js&"
export * from "./myCanvas.vue?vue&type=script&lang=js&"
import style0 from "./myCanvas.vue?vue&type=style&index=0&id=444f4278&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444f4278",
  null
  
)

export default component.exports